export default "__VITE_ASSET__CjXG4V2A__"